import React, { useEffect, useState } from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import jsPDF from 'jspdf';

const ViewQuoteDetailModalSale = ({ show, onHide, leadId, legalFeeData, leadData, calculationTotals }) => {
  console.log('🔍 ViewQuoteDetailModalSale - legalFeeData:', legalFeeData);
  console.log('🔍 ViewQuoteDetailModalSale - leadData:', leadData);
  console.log('🔍 ViewQuoteDetailModalSale - calculationTotals:', calculationTotals);

  const [feeTableHTML, setFeeTableHTML] = useState('');

  const formatCurrency = (amount) => {
    const value = Number(amount) || 0;
    return `£${value.toFixed(2)}`;
  };

  // Generate HTML fee table for Sale-Purchase (similar to Purchase)
  const generateSalePurchaseFeeTable = () => {
    const branchName = leadData?.branch_id?.branchname || leadData?.branch_id?.name || 'My Law Matters';
    const ownershipType = leadData?.ownership_type || 'Freehold';
    const serviceType = leadData?.service_type || 'Sale';

    // Calculate all fee components
    const legalFeeNet = legalFee;
    const legalFeeVAT = legalFee * 0.20;
    const legalFeeGross = legalFeeNet + legalFeeVAT;

    const ttFeeNet = ttFee;
    const ttFeeVAT = ttFee * 0.20;
    const ttFeeGross = ttFeeNet + ttFeeVAT;

    const identityCheckNet = identityCheck;
    const identityCheckVAT = 0;
    const identityCheckGross = identityCheckNet;

    const leaseholdFeeNet = leaseholdFee;
    const leaseholdFeeVAT = leaseholdFee * 0.20;
    const leaseholdFeeGross = leaseholdFeeNet + leaseholdFeeVAT;

    const mortgageAdminFeeNet = mortgageAdminFee;
    const mortgageAdminFeeVAT = mortgageAdminFee * 0.20;
    const mortgageAdminFeeGross = mortgageAdminFeeNet + mortgageAdminFeeVAT;

    const sharedOwnershipFeeNet = sharedOwnershipFee;
    const sharedOwnershipFeeVAT = sharedOwnershipFee * 0.20;
    const sharedOwnershipFeeGross = sharedOwnershipFeeNet + sharedOwnershipFeeVAT;

    const auctionRepossessionFeeNet = auctionRepossessionFee;
    const auctionRepossessionFeeVAT = auctionRepossessionFee * 0.20;
    const auctionRepossessionFeeGross = auctionRepossessionFeeNet + auctionRepossessionFeeVAT;

    const officialCopiesNet = officialCopies;
    const officialCopiesVAT = 0;
    const officialCopiesGross = officialCopiesNet;

    // Calculate Legal Cost totals
    const legalCostNet = legalFeeNet + leaseholdFeeNet + ttFeeNet + identityCheckNet +
      mortgageAdminFeeNet + sharedOwnershipFeeNet + auctionRepossessionFeeNet;
    const legalCostVAT = legalFeeVAT + leaseholdFeeVAT + ttFeeVAT + identityCheckVAT +
      mortgageAdminFeeVAT + sharedOwnershipFeeVAT + auctionRepossessionFeeVAT;
    const legalCostGross = legalCostNet + legalCostVAT;

    // Calculate Disbursement totals
    const disbursementCostNet = officialCopiesNet;
    const disbursementCostVAT = officialCopiesVAT;
    const disbursementCostGross = disbursementCostNet + disbursementCostVAT;

    // Calculate Grand totals
    const grandTotalNet = calculationTotals?.total?.net || totalNet;
    const grandTotalVAT = calculationTotals?.total?.vat || totalVAT;
    const grandTotalGross = calculationTotals?.total?.gross || totalGross;

    // Build HTML table
    let tableRows = '';

    // Legal Cost Section Header
    tableRows += `
      <tr style="background-color: #f8f9fa;">
        <td colspan="4" style="border: 1px solid #dee2e6; padding: 10px; font-weight: 600;">Legal Cost</td>
      </tr>
    `;

    // Legal Fees (always show)
    tableRows += `
      <tr>
        <td style="border: 1px solid #dee2e6; padding: 12px;">Legal Fees</td>
        <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(legalFeeNet)}</td>
        <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(legalFeeVAT)}</td>
        <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(legalFeeGross)}</td>
      </tr>
    `;

    // Leasehold Fee (only if applicable)
    if (leaseholdFeeNet > 0 && ownershipType.toLowerCase() === 'leasehold') {
      tableRows += `
        <tr>
          <td style="border: 1px solid #dee2e6; padding: 12px;">Leasehold Fee</td>
          <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(leaseholdFeeNet)}</td>
          <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(leaseholdFeeVAT)}</td>
          <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(leaseholdFeeGross)}</td>
        </tr>
      `;
    }

    // Mortgage Admin Fee
    if (mortgageAdminFeeNet > 0) {
      tableRows += `
        <tr>
          <td style="border: 1px solid #dee2e6; padding: 12px;">Mortgage Admin Fee</td>
          <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(mortgageAdminFeeNet)}</td>
          <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(mortgageAdminFeeVAT)}</td>
          <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(mortgageAdminFeeGross)}</td>
        </tr>
      `;
    }

    // TT Fee
    tableRows += `
      <tr>
        <td style="border: 1px solid #dee2e6; padding: 12px;">Telegraphic Transfer (TT) Fee</td>
        <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(ttFeeNet)}</td>
        <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(ttFeeVAT)}</td>
        <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(ttFeeGross)}</td>
      </tr>
    `;

    // Shared Ownership Fee
    if (sharedOwnershipFeeNet > 0) {
      tableRows += `
        <tr>
          <td style="border: 1px solid #dee2e6; padding: 12px;">Shared Ownership Fee</td>
          <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(sharedOwnershipFeeNet)}</td>
          <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(sharedOwnershipFeeVAT)}</td>
          <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(sharedOwnershipFeeGross)}</td>
        </tr>
      `;
    }

    // Auction/Repossession Fee
    if (auctionRepossessionFeeNet > 0) {
      tableRows += `
        <tr>
          <td style="border: 1px solid #dee2e6; padding: 12px;">Auction/Repossession Fee</td>
          <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(auctionRepossessionFeeNet)}</td>
          <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(auctionRepossessionFeeVAT)}</td>
          <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(auctionRepossessionFeeGross)}</td>
        </tr>
      `;
    }

    // Identity Check
    tableRows += `
      <tr>
        <td style="border: 1px solid #dee2e6; padding: 12px;">Identity Check</td>
        <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(identityCheckNet)}</td>
        <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(identityCheckVAT)}</td>
        <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(identityCheckGross)}</td>
      </tr>
    `;

    // Total Legal Cost
    tableRows += `
      <tr style="background-color: #e3f2fd; font-weight: 600;">
        <td style="border: 1px solid #dee2e6; padding: 12px;">TOTAL LEGAL COST</td>
        <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(calculationTotals?.legalCost?.net || legalCostNet)}</td>
        <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(calculationTotals?.legalCost?.vat || legalCostVAT)}</td>
        <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(calculationTotals?.legalCost?.gross || legalCostGross)}</td>
      </tr>
    `;

    // Disbursements Section Header
    tableRows += `
      <tr style="background-color: #f8f9fa;">
        <td colspan="4" style="border: 1px solid #dee2e6; padding: 10px; font-weight: 600;">Disbursement - Third Party Expenditure</td>
      </tr>
    `;

    // Official Copies
    tableRows += `
      <tr>
        <td style="border: 1px solid #dee2e6; padding: 12px;">Official Copies</td>
        <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(officialCopiesNet)}</td>
        <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">-</td>
        <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(officialCopiesGross)}</td>
      </tr>
    `;

    // Total Disbursement Cost
    tableRows += `
      <tr style="background-color: #e3f2fd; font-weight: 600;">
        <td style="border: 1px solid #dee2e6; padding: 12px;">TOTAL DISBURSEMENT COST</td>
        <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(calculationTotals?.disbursementCost?.net || disbursementCostNet)}</td>
        <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">-</td>
        <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right;">${formatCurrency(calculationTotals?.disbursementCost?.gross || disbursementCostGross)}</td>
      </tr>
    `;

    // Grand Total
    tableRows += `
      <tr style="background-color: #172554; font-weight: 700; color:white !important;">
        <td style="border: 1px solid #dee2e6; padding: 12px; color:white !important; font-weight: 700;">TOTAL (Legal Cost + Disbursement Cost)</td>
        <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right; color:white !important; font-weight: 700;">${formatCurrency(grandTotalNet)}</td>
        <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right; color:white !important; font-weight: 700;">${formatCurrency(grandTotalVAT)}</td>
        <td style="border: 1px solid #dee2e6; padding: 12px; text-align: right; color:white !important; font-weight: 700;">${formatCurrency(grandTotalGross)}</td>
      </tr>
    `;

    // Build complete HTML table
    const feeTableHTML = `
      <table style="width: 100%; border-collapse: collapse; margin-top: 20px; margin-bottom: 20px; font-family: Arial, sans-serif;">
        <thead>
          <tr style="background-color: #f8f9fa;">
            <th style="border: 1px solid #dee2e6; padding: 12px; text-align: left; width: 50%;">Description</th>
            <th style="border: 1px solid #dee2e6; padding: 12px; text-align: right; width: 16.66%;">Net</th>
            <th style="border: 1px solid #dee2e6; padding: 12px; text-align: right; width: 16.66%;">VAT</th>
            <th style="border: 1px solid #dee2e6; padding: 12px; text-align: right; width: 16.66%;">Gross</th>
          </tr>
        </thead>
        <tbody>
          ${tableRows}
        </tbody>
      </table>
    `;

    console.log('📊 Generated Sale-Purchase Fee Table HTML');
    return feeTableHTML;
  };

  const generatePDF = () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const margin = 20;
    const lineHeight = 7;
    let yPos = margin;

    // Generate dynamic quote header with current date/time
    const now = new Date();
    const formattedDate = now.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
    const formattedTime = now.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });
    const quoteHeader = `Quote #${leadData?.lead_id || leadId || 'N/A'}; Generated ${formattedDate} ${formattedTime}`;

    // Helper function to check if we need a new page
    const checkNewPage = (requiredSpace = 30) => {
      if (yPos + requiredSpace > pageHeight - margin) {
        doc.addPage();
        yPos = margin;
        doc.setPage(doc.internal.pages.length - 1);
        doc.setFontSize(9);
        doc.setTextColor(100);
        doc.text(quoteHeader, margin, pageHeight - 10);
        doc.setPage(doc.internal.pages.length);
        return true;
      }
      return false;
    };

    // Header
    doc.setFontSize(9);
    doc.setTextColor(100);
    doc.text(quoteHeader, margin, yPos);
    yPos += lineHeight + 5;

    // Lead ID
    doc.setFontSize(11);
    doc.setTextColor(0);
    doc.setFont('helvetica', 'bold');
    doc.text(`Lead ID: ${leadData?.lead_id || leadId || 'N/A'}`, margin, yPos);
    yPos += lineHeight;

    // Title
    doc.setFontSize(16);
    doc.setTextColor(0);
    doc.setFont('helvetica', 'bold');
    doc.text(`Quote for Conveyancing (Sale)`, margin, yPos);
    yPos += lineHeight + 3;

    // Subtitle
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text(`Legal Fees from My Law Matters of ${formatCurrency(totalGross)} inc. VAT`, margin, yPos);
    yPos += lineHeight + 8;

    // Introduction text
    doc.setFontSize(10);
    const introText = 'Thank you for requesting a conveyancing quote from My Law Matters, you will find a complete breakdown of our costs below. We would be delighted to act for you and one of our team will contact you shortly. In the meantime if you have any questions at all then please do get in touch on 0330 124 2171.';
    const introLines = doc.splitTextToSize(introText, pageWidth - 2 * margin);
    introLines.forEach(line => {
      doc.text(line, margin, yPos);
      yPos += lineHeight;
    });
    yPos += 10;

    // Table function
    const drawTable = (data, headers) => {
      const colWidths = [90, 30, 30, 30];
      let xPos = margin;

      // Draw headers
      doc.setFillColor(240, 240, 240);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10);

      let headerXPos = margin;
      headers.forEach((header, i) => {
        // Draw header cell background and border
        doc.setFillColor(240, 240, 240);
        doc.rect(headerXPos, yPos, colWidths[i], 8, 'F');
        doc.setDrawColor(200, 200, 200);
        doc.setLineWidth(0.1);
        doc.rect(headerXPos, yPos, colWidths[i], 8, 'S');

        // Draw header text
        doc.setTextColor(0, 0, 0);
        doc.text(header, headerXPos + 2, yPos + 5);
        headerXPos += colWidths[i];
      });
      yPos += 10;

      // Draw rows
      doc.setFont('helvetica', 'normal');
      data.forEach(row => {
        checkNewPage(8);
        xPos = margin;

        // Set font based on row type
        if (row.isGrandTotal) {
          doc.setFont('helvetica', 'bold');
          doc.setTextColor(0, 0, 0); // Black text for grand total
        } else if (row.isHeader) {
          doc.setFont('helvetica', 'bold');
          doc.setTextColor(0, 0, 0);
        } else {
          doc.setTextColor(0, 0, 0);
        }

        // Draw cell borders and content
        row.cells.forEach((cell, i) => {
          // Draw cell with background fill and border
          doc.setDrawColor(200, 200, 200); // Light gray border
          doc.setLineWidth(0.1);

          if (row.isGrandTotal) {
            doc.setFillColor(240, 240, 240); // Light gray background
            doc.rect(xPos, yPos, colWidths[i], 8, 'FD'); // Fill and Draw
          } else if (row.isHeader) {
            doc.setFillColor(240, 240, 240); // Light gray background
            doc.rect(xPos, yPos, colWidths[i], 8, 'FD'); // Fill and Draw
          } else {
            doc.rect(xPos, yPos, colWidths[i], 8, 'S'); // Stroke only
          }

          const text = String(cell || '');
          if (i > 0 && !row.isHeader && !row.isGrandTotal) {
            // Right align numbers
            const textWidth = doc.getTextWidth(text);
            doc.text(text, xPos + colWidths[i] - textWidth - 2, yPos + 5);
          } else {
            doc.text(text, xPos + 2, yPos + 5);
          }
          xPos += colWidths[i];
        });

        // Reset styling after row
        if (row.isHeader || row.isGrandTotal) {
          doc.setFont('helvetica', 'normal');
          doc.setTextColor(0, 0, 0); // Reset to black
        }
        yPos += 8;
      });
    };

    // Create table data for Sale
    const tableData = [
      { cells: ['Legal Cost', '', '', ''], isHeader: true },
      { cells: ['Legal Fees', formatCurrency(legalFee), formatCurrency(legalFeeVAT), formatCurrency(legalFeeGross)] },
    ];

    if (leaseholdFee > 0) {
      tableData.push({ cells: ['Leasehold Fee', formatCurrency(leaseholdFee), formatCurrency(leaseholdFeeVAT), formatCurrency(leaseholdFeeGross)] });
    }
    if (mortgageAdminFee > 0) {
      tableData.push({ cells: ['Mortgage Admin Fee', formatCurrency(mortgageAdminFee), formatCurrency(mortgageAdminFeeVAT), formatCurrency(mortgageAdminFeeGross)] });
    }
    tableData.push({ cells: ['Telegraphic Transfer (TT) Fee', formatCurrency(ttFee), formatCurrency(ttFeeVAT), formatCurrency(ttFeeGross)] });
    if (sharedOwnershipFee > 0) {
      tableData.push({ cells: ['Shared Ownership Fee', formatCurrency(sharedOwnershipFee), formatCurrency(sharedOwnershipFeeVAT), formatCurrency(sharedOwnershipFeeGross)] });
    }
    if (auctionRepossessionFee > 0) {
      tableData.push({ cells: ['Auction/Repossession Fee', formatCurrency(auctionRepossessionFee), formatCurrency(auctionRepossessionFeeVAT), formatCurrency(auctionRepossessionFeeGross)] });
    }
    tableData.push({ cells: ['Identity Check', formatCurrency(identityCheck), formatCurrency(identityCheckVAT), formatCurrency(identityCheckGross)] });
    tableData.push({ cells: ['Disbursements', '', '', ''], isHeader: true });
    tableData.push({ cells: ['Official Copies', formatCurrency(officialCopies), formatCurrency(officialCopiesVAT), formatCurrency(officialCopiesGross)] });
    tableData.push({ cells: ['', '', '', ''] }); // Empty row for spacing
    // 🎯 Grand Total Row - Blue background with white text
    tableData.push({ cells: ['TOTAL (Legal Cost + Disbursement Cost)', formatCurrency(totalNet), formatCurrency(totalVAT), formatCurrency(totalGross)], isGrandTotal: true });

    drawTable(tableData, ['Description', 'Net', 'VAT', 'Gross']);
    yPos += 10;

    // Mortgaged Section
    checkNewPage(50);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.text('Mortgaged', margin, yPos);
    yPos += lineHeight;

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    const mortgagedText = 'If you are selling a property with an outstanding mortgage we are often required to act on the mortgage lender\'s behalf to ensure the mortgage is repaid and an additional fee for dealing with these formalities is charged.';
    const mortgagedLines = doc.splitTextToSize(mortgagedText, pageWidth - 2 * margin);
    mortgagedLines.forEach(line => {
      checkNewPage(8);
      doc.text(line, margin, yPos);
      yPos += lineHeight;
    });
    yPos += 10;

    // Identification Section
    checkNewPage(50);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.text('Identification', margin, yPos);
    yPos += lineHeight;

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    const identificationText = 'In order to comply with Money Laundering regulations we are required to verify the identity of all clients we act for, we therefore carry out an online identification verification service. Money Laundering - In order to comply with Money Laundering legislation, we are required to verify the identity of all clients. You will be asked to provide original copies or certified copies of your identification. These can be brought into the office for copying or posted to us.';
    const identificationLines = doc.splitTextToSize(identificationText, pageWidth - 2 * margin);
    identificationLines.forEach(line => {
      checkNewPage(8);
      doc.text(line, margin, yPos);
      yPos += lineHeight;
    });

    // Footer on last page
    doc.setFontSize(9);
    doc.setTextColor(100);
    doc.text(quoteHeader, margin, pageHeight - 10);

    // Save the PDF
    doc.save(`Quote_Sale_${leadData?.lead_id || leadId || 'Unknown'}_${new Date().getTime()}.pdf`);
  };

  const downloadQuote = () => {
    generatePDF();
  };

  // Calculate all fees for Sale
  const legalFee = legalFeeData?.legal_fee !== undefined
    ? Number(legalFeeData.legal_fee)
    : (leadData?.legal_fee !== undefined ? Number(leadData.legal_fee) : 0);
  const legalFeeVAT = legalFee * 0.20;
  const legalFeeGross = legalFee + legalFeeVAT;

  const ttFee = (legalFeeData && legalFeeData.tt_fee !== undefined) ? Number(legalFeeData.tt_fee) : Number(leadData?.tt_fee || 30);
  const ttFeeVAT = ttFee * 0.20;
  const ttFeeGross = ttFee + ttFeeVAT;

  // Get number of sellers for Sale
  const numberOfSellers = Number(leadData?.num_sellers || leadData?.number_of_sellers || 1);
  // Helper function to check if value is truthy (true, "Yes", 1)
  const isTruthy = (value) => {
    if (value === true || value === 1 || value === "1") return true;
    if (typeof value === 'string' && value.toLowerCase() === 'yes') return true;
    return false;
  };

  // Helper function to get fee value and calculate VAT (same as Purchase modal)
  const getFeeWithVAT = (feeKey, hasVAT = true) => {
    // Try multiple paths to find the fee data
    // 1. Try legalFeeData.api_response.fees.camelCaseKey (from calculation document)
    let feeData = legalFeeData?.api_response?.fees?.[feeKey];

    // 2. Try legalFeeData.fees.camelCaseKey (direct API response)
    if (!feeData) {
      feeData = legalFeeData?.fees?.[feeKey];
    }

    if (feeData && typeof feeData === 'object') {
      // API returns {amount, vat, gross, label} structure
      return {
        net: Number(feeData.amount || 0),
        vat: Number(feeData.vat || 0),
        gross: Number(feeData.gross || 0)
      };
    }

    // 3. Fallback to snake_case root level keys
    // Convert camelCase to snake_case for lookup
    const snakeKey = feeKey.replace(/([A-Z])/g, '_$1').toLowerCase();
    const net = Number(legalFeeData?.[snakeKey] || legalFeeData?.[feeKey] || leadData?.[snakeKey] || leadData?.[feeKey] || 0);
    const vat = hasVAT ? net * 0.20 : 0;
    const gross = net + vat;
    return { net, vat, gross };
  };

  // Get sale info for conditional fee checks
  const saleInfo = leadData?.sale_details_info || leadData?.salePropertyDetails || leadData?.info || {};

  // Get number of sellers for identity check calculation
  const vendorCount = leadData?.vendors?.length || leadData?.customer_ids?.length || leadData?.customers?.length || numberOfSellers || 1;
  console.log('👥 Vendor/Seller Count for Identity Check:', vendorCount);

  // Calculate Identity Check - multiply by vendor count
  const identityCheckBase = Number(
    legalFeeData?.api_response?.fees?.identityCheck?.amount ||
    legalFeeData?.fees?.identityCheck?.amount ||
    legalFeeData?.identity_check ||
    leadData?.identity_check ||
    10
  );
  const identityCheck = identityCheckBase * vendorCount;
  const identityCheckVAT = 0; // ❌ Identity Check has NO VAT (third-party cost)
  const identityCheckGross = identityCheck;

  console.log('🔍 Identity Check Calculation:', {
    base: identityCheckBase,
    vendorCount: vendorCount,
    total: identityCheck
  });

  // All Fixed Fees - using getFeeWithVAT helper for consistency
  const leaseholdFeeObj = getFeeWithVAT('leaseholdFee');
  const leaseholdFee = leaseholdFeeObj.net;
  const leaseholdFeeVAT = leaseholdFeeObj.vat;
  const leaseholdFeeGross = leaseholdFeeObj.gross;

  const mortgageAdminFeeObj = getFeeWithVAT('mortgageAdminFee');
  const mortgageAdminFee = mortgageAdminFeeObj.net;
  const mortgageAdminFeeVAT = mortgageAdminFeeObj.vat;
  const mortgageAdminFeeGross = mortgageAdminFeeObj.gross;

  const sharedOwnershipFeeObj = getFeeWithVAT('sharedOwnershipFee');
  const sharedOwnershipFee = sharedOwnershipFeeObj.net;
  const sharedOwnershipFeeVAT = sharedOwnershipFeeObj.vat;
  const sharedOwnershipFeeGross = sharedOwnershipFeeObj.gross;

  const auctionRepossessionFeeObj = getFeeWithVAT('auctionRepossessionFee');
  const auctionRepossessionFee = auctionRepossessionFeeObj.net;
  const auctionRepossessionFeeVAT = auctionRepossessionFeeObj.vat;
  const auctionRepossessionFeeGross = auctionRepossessionFeeObj.gross;

  // Disbursements - using getFeeWithVAT helper
  const officialCopiesObj = getFeeWithVAT('officialCopies', false); // Government fee - no VAT
  const officialCopies = officialCopiesObj.net;
  const officialCopiesVAT = 0; // No VAT on official copies
  const officialCopiesGross = officialCopies;

  // 🎯 Use totals from database if available, otherwise calculate
  let totalNet, totalVAT, totalGross;

  if (calculationTotals) {
    // Use totals from leads_calculations table (database)
    console.log('💾 Using totals from DATABASE:', calculationTotals);
    totalNet = calculationTotals.net || 0;
    totalVAT = calculationTotals.vat || 0;
    totalGross = calculationTotals.gross || 0;
  } else {
    // Fallback: Calculate totals (old logic)
    console.log('🔢 Calculating totals (no database totals available)');
    totalNet = legalFee + ttFee + identityCheck + leaseholdFee + mortgageAdminFee + sharedOwnershipFee + auctionRepossessionFee + officialCopies;
    totalVAT = legalFeeVAT + ttFeeVAT + identityCheckVAT + leaseholdFeeVAT + mortgageAdminFeeVAT + sharedOwnershipFeeVAT + auctionRepossessionFeeVAT + officialCopiesVAT;
    totalGross = totalNet + totalVAT;
  }

  // Log data when modal opens
  useEffect(() => {
    if (show) {
      console.log('📊 === VIEW QUOTE DETAIL MODAL (SALE) OPENED ===');
      console.log('🔍 legalFeeData:', legalFeeData);
      console.log('📋 leadData:', leadData);
      console.log('💰 calculationTotals:', calculationTotals);

      if (legalFeeData) {
        console.log('✅ Modal opened with API data:', {
          legal_fee: legalFeeData.legal_fee,
          tt_fee: legalFeeData.tt_fee,
          identity_check: legalFeeData.identity_check,
          official_copies: legalFeeData.official_copies,
          mortgage_admin_fee: legalFeeData.mortgage_admin_fee,
          leasehold_fee: legalFeeData.leasehold_fee
        });
      } else {
        console.log('⚠️ No legalFeeData available, using leadData fallback');
      }

      console.log('💷 Calculated totals being displayed:', {
        totalNet: totalNet,
        totalVAT: totalVAT,
        totalGross: totalGross,
        fromDatabase: !!calculationTotals
      });

      // Generate fee_table HTML for email templates and exports
      const generatedFeeTable = generateSalePurchaseFeeTable();
      setFeeTableHTML(generatedFeeTable);
      console.log('✅ Fee Table HTML generated for Sale-Purchase view quote');
    }
  }, [show, legalFeeData, leadData, calculationTotals, totalNet, totalVAT, totalGross]);

  // Function to copy fee table HTML to clipboard
  const copyFeeTableToClipboard = () => {
    if (feeTableHTML) {
      navigator.clipboard.writeText(feeTableHTML)
        .then(() => {
          alert('Fee table HTML copied to clipboard!');
        })
        .catch(err => {
          console.error('Failed to copy fee table:', err);
          alert('Failed to copy fee table to clipboard');
        });
    }
  };

  // Function to download fee table as HTML file
  const downloadFeeTableHTML = () => {
    if (!feeTableHTML) return;

    const htmlContent = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>Sale Quote - Fee Table</title>
  <style>
    body { font-family: Arial, sans-serif; padding: 20px; }
    h2 { color: #2c3e50; }
  </style>
</head>
<body>
  <h2>Quote for Conveyancing (Sale) - Lead #${leadData?.lead_id || leadId || 'N/A'}</h2>
  ${feeTableHTML}
</body>
</html>
    `;

    const blob = new Blob([htmlContent], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `Fee_Table_Sale_${leadData?.lead_id || leadId || 'Unknown'}_${new Date().getTime()}.html`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>View Quote</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Service Type */}
        <div className="mb-3">
          <h6>Sale</h6>
        </div>

        {/* Quote Table */}
        <Table bordered>
          <thead>
            <tr>
              <th style={{ width: '50%' }}></th>
              <th className="text-end" style={{ width: '16.66%' }}>Net</th>
              <th className="text-end" style={{ width: '16.66%' }}>VAT</th>
              <th className="text-end" style={{ width: '16.66%' }}>Gross</th>
            </tr>
          </thead>
          <tbody>
            {/* Legal Cost Section */}
            <tr style={{ backgroundColor: '#f8f9fa' }}>
              <td colSpan="4"><strong>Legal Cost</strong></td>
            </tr>
            <tr>
              <td>Legal Fees</td>
              <td className="text-end">{formatCurrency(legalFee)}</td>
              <td className="text-end">{formatCurrency(legalFeeVAT)}</td>
              <td className="text-end">{formatCurrency(legalFeeGross)}</td>
            </tr>

            {/* Leasehold Fee */}
            {leaseholdFee > 0 && leadData?.ownership_type === 'Leasehold' && (
              <tr>
                <td>Leasehold Fee</td>
                <td className="text-end">{formatCurrency(leaseholdFee)}</td>
                <td className="text-end">{formatCurrency(leaseholdFeeVAT)}</td>
                <td className="text-end">{formatCurrency(leaseholdFeeGross)}</td>
              </tr>
            )}

            {/* Mortgage Admin Fee */}
            {mortgageAdminFee > 0 && (isTruthy(leadData?.info?.sellingWithMortgage) || isTruthy(saleInfo?.sellingWithMortgage) || isTruthy(leadData?.info?.sellingWithMortgage)) && (
              <tr>
                <td>Mortgage Admin Fee</td>
                <td className="text-end">{formatCurrency(mortgageAdminFee)}</td>
                <td className="text-end">{formatCurrency(mortgageAdminFeeVAT)}</td>
                <td className="text-end">{formatCurrency(mortgageAdminFeeGross)}</td>
              </tr>
            )}

            {/* TT Fee */}
            <tr>
              <td>Telegraphic Transfer (TT) Fee</td>
              <td className="text-end">{formatCurrency(ttFee)}</td>
              <td className="text-end">{formatCurrency(ttFeeVAT)}</td>
              <td className="text-end">{formatCurrency(ttFeeGross)}</td>
            </tr>

            {/* Shared Ownership Fee */}
            {sharedOwnershipFee > 0 && (isTruthy(saleInfo?.shared_ownership) || isTruthy(leadData?.info?.sharedOwnership) || isTruthy(leadData?.info?.sharedOwnership)) && (
              <tr>
                <td>Shared Ownership Fee</td>
                <td className="text-end">{formatCurrency(sharedOwnershipFee)}</td>
                <td className="text-end">{formatCurrency(sharedOwnershipFeeVAT)}</td>
                <td className="text-end">{formatCurrency(sharedOwnershipFeeGross)}</td>
              </tr>
            )}

            {/* Auction/Repossession Fee */}
            {auctionRepossessionFee > 0 && isTruthy(leadData?.info?.auctionRepossession) && (
              <tr>
                <td>Auction/Repossession Fee</td>
                <td className="text-end">{formatCurrency(auctionRepossessionFee)}</td>
                <td className="text-end">{formatCurrency(auctionRepossessionFeeVAT)}</td>
                <td className="text-end">{formatCurrency(auctionRepossessionFeeGross)}</td>
              </tr>
            )}

            {/* Identity Check */}
            <tr>
              <td>Identity Check</td>
              <td className="text-end">{formatCurrency(identityCheck)}</td>
              <td className="text-end">{formatCurrency(identityCheckVAT)}</td>
              <td className="text-end">{formatCurrency(identityCheckGross)}</td>
            </tr>

            {/* Total Legal Cost */}
            <tr style={{ backgroundColor: '#e3f2fd', fontWeight: '600' }}>
              <td>TOTAL LEGAL COST</td>
              <td className="text-end">{formatCurrency(
                calculationTotals?.legalCost?.net || (
                  legalFee + leaseholdFee + mortgageAdminFee + ttFee +
                  sharedOwnershipFee + auctionRepossessionFee + identityCheck
                )
              )}</td>
              <td className="text-end">{formatCurrency(
                calculationTotals?.legalCost?.vat || (
                  legalFeeVAT + leaseholdFeeVAT + mortgageAdminFeeVAT + ttFeeVAT +
                  sharedOwnershipFeeVAT + auctionRepossessionFeeVAT + identityCheckVAT
                )
              )}</td>
              <td className="text-end">{formatCurrency(
                calculationTotals?.legalCost?.gross || (
                  legalFeeGross + leaseholdFeeGross + mortgageAdminFeeGross + ttFeeGross +
                  sharedOwnershipFeeGross + auctionRepossessionFeeGross + identityCheckGross
                )
              )}</td>
            </tr>

            {/* Disbursement Section */}
            <tr style={{ backgroundColor: '#f8f9fa' }}>
              <td colSpan="4"><strong>Disbursement - Third Party Expenditure</strong></td>
            </tr>
            <tr>
              <td>Official Copies</td>
              <td className="text-end">{formatCurrency(officialCopies)}</td>
              <td className="text-end">-</td>
              <td className="text-end">{formatCurrency(officialCopiesGross)}</td>
            </tr>

            {/* Total Disbursement Cost */}
            <tr style={{ backgroundColor: '#e3f2fd', fontWeight: '600' }}>
              <td>TOTAL DISBURSEMENT COST</td>
              <td className="text-end">{formatCurrency(
                calculationTotals?.disbursementCost?.net || officialCopies
              )}</td>
              <td className="text-end">-</td>
              <td className="text-end">{formatCurrency(
                calculationTotals?.disbursementCost?.gross || officialCopiesGross
              )}</td>
            </tr>

            {/* Grand Total Row */}
            <tr style={{ backgroundColor: '#172554', fontWeight: '700', color: 'white' }}>
              <td style={{ color: 'white', fontWeight: '700' }}>TOTAL (Legal Cost + Disbursement Cost)</td>
              <td className="text-end" style={{ color: 'white', fontWeight: '700' }}>{formatCurrency(
                calculationTotals?.total?.net || totalNet
              )}</td>
              <td className="text-end" style={{ color: 'white', fontWeight: '700' }}>{formatCurrency(
                calculationTotals?.total?.vat || totalVAT
              )}</td>
              <td className="text-end" style={{ color: 'white', fontWeight: '700' }}>{formatCurrency(
                calculationTotals?.total?.gross || totalGross
              )}</td>
            </tr>
          </tbody>
        </Table>

        {/* Mortgaged Section */}
        <div className="p-3 mb-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
          <h6 className="mb-2">Mortgaged</h6>
          <p style={{ fontSize: '14px', lineHeight: '1.6', marginBottom: 8 }}>
            If you are selling a property with an outstanding mortgage we are often required to act on the mortgage lender's behalf to ensure the mortgage is repaid and an additional fee for dealing with these formalities is charged.
          </p>
          {mortgageAdminFee > 0 && (
            <p style={{ fontSize: '14px', lineHeight: '1.6', marginBottom: 0 }}>
              <strong>Mortgage Admin Fee:</strong> {formatCurrency(mortgageAdminFee)}
            </p>
          )}
        </div>

        {/* Identification Section */}
        <div className="p-3 mb-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
          <h6 className="mb-2">Identification</h6>
          <p style={{ fontSize: '14px', lineHeight: '1.6', marginBottom: 0 }}>
            In order to comply with Money Laundering regulations we are required to verify the identity of all clients we act for, we therefore carry out an online identification verification service. Money Laundering - In order to comply with Money Laundering legislation, we are required to verify the identity of all clients. You will be asked to provide original copies or certified copies of your identification. These can be brought into the office for copying or posted to us.
          </p>
        </div>

        {/* Fee Table Data Section (Key-Value Pairs) */}
        <div className="p-3 mb-3" style={{ backgroundColor: '#e8f5e9', borderRadius: '5px', border: '1px solid #c8e6c9' }}>
          <h6 className="mb-3" style={{ color: '#2e7d32' }}>
            <i className="bi bi-table"></i> Fee Table Data (Key-Value Pairs)
          </h6>
          <div style={{ fontSize: '13px', fontFamily: 'monospace' }}>
            <div className="row mb-2">
              <div className="col-6" style={{ fontWeight: '600' }}>legal_fee:</div>
              <div className="col-6">{formatCurrency(legalFee)}</div>
            </div>
            <div className="row mb-2">
              <div className="col-6" style={{ fontWeight: '600' }}>tt_fee:</div>
              <div className="col-6">{formatCurrency(ttFee)}</div>
            </div>
            <div className="row mb-2">
              <div className="col-6" style={{ fontWeight: '600' }}>identity_check:</div>
              <div className="col-6">{formatCurrency(identityCheck)}</div>
            </div>
            {leaseholdFee > 0 && (
              <div className="row mb-2">
                <div className="col-6" style={{ fontWeight: '600' }}>leasehold_fee:</div>
                <div className="col-6">{formatCurrency(leaseholdFee)}</div>
              </div>
            )}
            {mortgageAdminFee > 0 && (
              <div className="row mb-2">
                <div className="col-6" style={{ fontWeight: '600' }}>mortgage_admin_fee:</div>
                <div className="col-6">{formatCurrency(mortgageAdminFee)}</div>
              </div>
            )}
            {sharedOwnershipFee > 0 && (
              <div className="row mb-2">
                <div className="col-6" style={{ fontWeight: '600' }}>shared_ownership_fee:</div>
                <div className="col-6">{formatCurrency(sharedOwnershipFee)}</div>
              </div>
            )}
            {auctionRepossessionFee > 0 && (
              <div className="row mb-2">
                <div className="col-6" style={{ fontWeight: '600' }}>auction_repossession_fee:</div>
                <div className="col-6">{formatCurrency(auctionRepossessionFee)}</div>
              </div>
            )}
            <div className="row mb-2">
              <div className="col-6" style={{ fontWeight: '600' }}>official_copies:</div>
              <div className="col-6">{formatCurrency(officialCopies)}</div>
            </div>
            <hr style={{ margin: '10px 0', borderTop: '2px solid #2e7d32' }} />
            <div className="row mb-2" style={{ fontWeight: '700', color: '#1b5e20' }}>
              <div className="col-6">total_net:</div>
              <div className="col-6">{formatCurrency(totalNet)}</div>
            </div>
            <div className="row mb-2" style={{ fontWeight: '700', color: '#1b5e20' }}>
              <div className="col-6">total_vat:</div>
              <div className="col-6">{formatCurrency(totalVAT)}</div>
            </div>
            <div className="row mb-2" style={{ fontWeight: '700', color: '#1b5e20', fontSize: '15px' }}>
              <div className="col-6">total_gross:</div>
              <div className="col-6">{formatCurrency(totalGross)}</div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-info" onClick={copyFeeTableToClipboard} title="Copy fee table HTML to clipboard">
          <i className="bi bi-clipboard"></i> Copy HTML
        </Button>
        <Button variant="outline-primary" onClick={downloadFeeTableHTML} title="Download fee table as HTML file">
          <i className="bi bi-file-earmark-code"></i> Export HTML
        </Button>
        <Button variant="outline-secondary" onClick={downloadQuote}>
          <i className="bi bi-download"></i> Download PDF
        </Button>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewQuoteDetailModalSale;
